import { MsaasJobListing } from '~/types/hlx/msaasJobListing';
import { LABOR_REQ_TYPE_OPTIONS } from './constants';
import { LaborMetricsFormValues } from './types';

export const transformApiToLaborMetricsForm = (
  msaasListing: MsaasJobListing
): LaborMetricsFormValues => {
  return {
    id: msaasListing.detail?.id,
    msaasListingId: msaasListing.id,
    startDate: msaasListing.detail?.startDate || '',
    endDate: msaasListing.detail?.endDate || '',
    // [MCV-1541][MCV-1545] Conditionally-required figures hydrate as null rather
    // than 0. Defaulting them to 0 re-created the bug on an existing listing:
    // the field read as filled to the validator while showing nothing usable.
    numOfFtes: msaasListing.detail?.numOfFtes ?? null,
    fteShiftsPerYear: msaasListing.detail?.fteShiftsPerYear || 0,
    hoursPerShift: msaasListing.detail?.hoursPerShift || 0,
    minRvusPerShift: msaasListing.detail?.minRvusPerShift ?? null,
    numRvusReq: msaasListing.detail?.numRvusReq ?? null,
    laborReqType:
      LABOR_REQ_TYPE_OPTIONS.find(
        (option: { value: string }) => option.value === msaasListing.detail?.laborReqType
      ) || LABOR_REQ_TYPE_OPTIONS[0],
  };
};
